import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import {
  certificatesApi as API,
} from "../../apis/certificates";
import { RootState } from "../store";

export const loadCertificates = createAsyncThunk(
  "certificate/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { certificates } = getState() as RootState;
      if (certificates.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Certificate>();
interface Certificates extends EntityState<Certificate> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: Certificates = {
  ...itemsAdapter.getInitialState(),
  status: "idle"
};

const slice = createSlice({
  name: "certificates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCertificates.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadCertificates.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadCertificates.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, payload.data);
      });
  },
});

export default slice.reducer;
